import { Component, HostBinding, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { isEqual, cloneDeep } from 'lodash';
import { CmsFormsService } from '../forms.service';
import { CmsNotificationsService } from '../../core/notifications.service';
import { CmsNotifyService } from '../../core/notify.service';
import { CmsTranslateService } from '../../shared/translate.service';
import { validateJson } from '../../shared/json-editor/json-validator.directive';
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'cms-edit-form-template',
    templateUrl: 'edit-form-template.component.html',
    providers: [CmsFormsService]
})

export class CmsEditFormTemplateComponent implements OnInit {
    @HostBinding('class') classes = 'popup-overlay';
    form: FormGroup;
    originalData: any;
    valueChanged: boolean = false;
    titleValidationInterpolationParams;

    constructor(
        private router: Router,
        private fb: FormBuilder,
        private notificationsService: CmsNotificationsService,
        private notifyService: CmsNotifyService,
        private translateService: CmsTranslateService,
        private formService: CmsFormsService,
        private activeRoute: ActivatedRoute
    ) {
        this.form = this.fb.group({
            appTemplate: this.fb.group({
                title: [{ value: '', disabled: true }]
            }),
            name: [{value: '', disabled: true}],
            title: ['', [Validators.required, Validators.maxLength(120)]],
            data: [{}, [Validators.required, validateJson]],
            active: [true, []]
        });

        this.titleValidationInterpolationParams = {
            field: this.translateService.translate('common_title').toLowerCase(),
            maximum: '120'
        };

        this.activeRoute.params.subscribe((params: {formTemplateId: string}) => {
            this.formService.getFormTemplate({
                formTemplateId: params.formTemplateId,
                search: {extend: 'appTemplate'}
            }).subscribe(res => {
                this.originalData = cloneDeep(res.appFormTemplate);
                this.form.patchValue(res.appFormTemplate);
            });
        });
    }

    ngOnInit() {
        this.form.valueChanges
            .pipe(debounceTime(200))
            .subscribe((formTemplate: any) => {
                this.valueChanged = !(isEqual(formTemplate.title, this.originalData.title)
                    && isEqual(formTemplate.data, this.originalData.data)
                    && isEqual(formTemplate.active, this.originalData.active));
            });
    }

    onSubmit(form: FormGroup) {
        this.formService.updateFormTemplate({
            formTemplateId: this.activeRoute.snapshot.params['formTemplateId'],
            title: form.value.title,
            data: form.value.data,
            active: form.value.active
        }).subscribe(
            res => {
                this.notificationsService.show({
                    type: 'action',
                    content: this.translateService.translate('forms_edit_form_success')
                });
                this.closePopup().then( () => {
                    this.notifyService.notify('formTemplateEdit');
                });
            },
            error => {
                this.notificationsService.show({
                    type: 'error',
                    content: error.message
                });
            }
        );
    }

    closePopup() {
        return this.router.navigate(
            [{outlets: {popup: null}}],
            {queryParamsHandling: 'preserve'}
        );
    }
}
